import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import './index.css';

// Dev-only: strip known noisy non-DOM props leaking from kepler / styled pipelines
if (import.meta.env.DEV) {
  const INVALID_PROP_SET = new Set([
    'isEditingLabel',
    'isValid',
    'active',
    'labelRCGColorValues',
    'isConfigActive',
  ]);
  // Keep reference to original
  const origCreateElement = React.createElement;
  (React as any).createElement = function patchedCreateElement(
    type: any,
    props: any,
    ...rest: any[]
  ) {
    if (props && typeof type === 'string') {
      // only strip for host DOM elements
      let mutated = false;
      for (const key of Object.keys(props)) {
        if (INVALID_PROP_SET.has(key)) {
          if (!mutated) props = { ...props }; // shallow clone once
          delete props[key];
          mutated = true;
        }
        // Handle boolean-ish custom attribute 'active' when explicitly false -> remove entirely
        if (key === 'active' && props[key] === false) {
          if (!mutated) props = { ...props };
          delete props[key];
          mutated = true;
        }
      }
    }
    return origCreateElement(type, props, ...rest);
  };
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
